var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareProvider(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "14px",
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shares",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shares-#14---Fidelity-added-Copy-3",
    transform: "translate(-116.000000, -496.000000)",
    stroke: "#333852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(48.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(38.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(31.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "0 8.68188049 15 8.68188049 15 0 0 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.33267091,
    y1: 8.81957907,
    x2: 6.33267091,
    y2: 11.5067817,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.66762719,
    y1: 8.81957907,
    x2: 8.66762719,
    y2: 11.5067817,
    id: "Stroke-4"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-6",
    points: "3.29709857 6.51663576 3.29709857 2.77177647 4.97635135 2.77177647 4.97635135 3.13948875 4.97635135 6.51663576"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    points: "6.73509539 6.51663576 6.73509539 3.13948875 4.97635135 3.13948875 4.81736884 3.13948875"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-8",
    points: "6.80465024 4.32003871 8.46403021 4.32003871 8.46403021 6.51663576"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-9",
    points: "10.0836645 6.51663576 10.0836645 5.09416983 10.0836645 4.88128377 8.55345787 4.88128377"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-10",
    points: "11.7032989 6.51663576 11.7032989 5.09416983 10.0836645 5.09416983 9.95449126 5.09416983"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.28348569,
    y1: 11.5161681,
    x2: 11.7165143,
    y2: 11.5161681,
    id: "Stroke-11"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareProvider);
export default __webpack_public_path__ + "static/media/share-provider.00c4b3398010b87c511ed17b2b1eb8b3.svg";
export { ForwardRef as ReactComponent };